// src/utils/SharedAudio.js

let audioContext = null;
let isUnlocked = false;

// Push/FCM callbacks are not user gestures, so they cannot unlock audio on
// their own. Register this once while the app is visible and unlock on the
// user's first interaction instead.
export function installAudioUnlockListener() {
    if (typeof window === "undefined" || isUnlocked) return () => {};

    const unlock = () => {
        userGestureInitAudio().catch((error) =>
            console.warn("[Audio] Could not unlock AudioContext", error)
        );
        removeListeners();
    };

    const events = ["pointerdown", "touchstart", "keydown"];
    const removeListeners = () => {
        events.forEach((eventName) =>
            window.removeEventListener(eventName, unlock, true)
        );
    };

    events.forEach((eventName) =>
        window.addEventListener(eventName, unlock, { capture: true, once: true })
    );

    return removeListeners;
}

export function userGestureInitAudio() {
    // MUST be called from a real user gesture (click/tap/keypress)
    if (!audioContext) {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }

    if (audioContext.state === "suspended") {
        return audioContext.resume().then(() => {
            isUnlocked = true;
            console.log("[Audio] AudioContext unlocked");
        });
    } else {
        isUnlocked = true;
        console.log("[Audio] AudioContext already running");
        return Promise.resolve();
    }
}

// Returns context ONLY if user has unlocked it
export function getUnlockedAudioContext() {
    if (!isUnlocked || !audioContext) {
        console.warn("[Audio] Tried to use audio before unlock");
        return null;
    }
    return audioContext;
}
